import React from "react";
import { Paper, Typography } from "@mui/material";

const CARD_BORDER = "1px solid #ececf0";

type MetricCardProps = {
  label: string;
  value: any;
  accent: string;
  sub?: string;
};

const MetricCard: React.FC<MetricCardProps> = ({ label, value, accent, sub }) => (
  <Paper
    elevation={0}
    sx={{
      flex: "1 1 150px",
      p: 2.5,
      borderRadius: "16px",
      border: CARD_BORDER,
      borderTop: `3px solid ${accent}`,
      backgroundColor: "white",
      textAlign: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: "2rem",
        fontWeight: 800,
        color: "#2c2c34",
        lineHeight: 1.1,
      }}
    >
      {value}
    </Typography>
    <Typography
      variant="caption"
      sx={{
        color: "#8a8a93",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        fontWeight: 600,
        display: "block",
      }}
    >
      {label}
    </Typography>
    {sub ? (
      <Typography variant="caption" sx={{ color: "#b0b0b8" }}>
        {sub}
      </Typography>
    ) : null}
  </Paper>
);

export default MetricCard;
